import React from 'react';
import {entity as webSnippets} from '../../ducks/webSnippets';
import SnippetList from './SnippetList';
import SnippetEditor from './SnippetEditor';
import duckify from "../../utils/duckify";
import {withSnippetFunctions} from "./snippetUtils";
import {compose} from "redux";

const WebSnippetList = (props) => (
 <SnippetList
    collectionButtons={[]}
    displayName="Web"
    editModal={SnippetEditor}
    editModalProps={{htmlAllowDangerousTags: true}}
    type="web"
    {...props}
 />
);

const mapDucksToProps = () => ({
    items: webSnippets,
});

export default compose(
  withSnippetFunctions(webSnippets),
  duckify(mapDucksToProps)
)(WebSnippetList);
